export default __webpack_public_path__ + "static/media/Slide23.6f1f5956.JPG";